import AdressCustomerComponent from "./AdressCustomerComponent";
import {useEffect, useReducer} from "react";
import Button1 from "../../UI/Button1";
import {collection, query, where, getDocs, setDoc, doc, deleteDoc} from "firebase/firestore";
import {auth, db} from "../../firebase/firebase";
import { signInWithCustomToken } from "firebase/auth";


const initialState = {
    customerAdresses : []
}

const reducer = (state, action) => {
    switch (action.type){
        case 'ADD_CUSTOMER':
            return {...state, customerAdresses: 
                    [...state.customerAdresses, action.payload]}
        case 'DELETE_CUSTOMER':
            return {...state, customerAdresses: 
                    state.customerAdresses.
                    filter((_, index) => 
                        index !== action.payload)}
        case 'SET_ADDRESSES': 
            return { ...state, customerAdresses: action.payload}
        default:
            return state;
    }
}

const ListOfAdressCustomerComponents = ({ customerID, id }) => {
    const[state, dispatch] = useReducer(reducer, initialState);
    
    const token = localStorage.getItem('token');
    
    
    console.log("List of address customer components => ID: ", customerID, " and ID is: " + id);
    useEffect(() => {
        console.log("List of customer adress useeffect: ID => ", customerID);

        if (token){
            signInWithCustomToken(auth, token)
                .then(() => {
                    console.log("User signed in with custom token.");
                })
                .catch((error) => {
                    console.error("Error signing in with custom token.");
                });
        }
        
        const fetchAddresses = async () => {
            if (customerID) {
                console.log("Fetching all adresses");
                const q = query(collection(db,
                    `customerAddresses/${customerID}/addresses`));
                const querySnapshot = await getDocs(q);
                
                const addresses = querySnapshot.docs.map
                (doc => doc.data());
                
                console.log("Fetched adresses =>", addresses);
                
                dispatch({type: 'SET_ADDRESSES', payload: addresses});
            }
        }
        fetchAddresses();
    }, [customerID, token]);
    
    const addCustomer = (address) => {
        dispatch({type: 'ADD_CUSTOMER', payload: address});
    };
    
    const deleteCustomer = async (index) => {
        console.log("Should delete address with index: " , index);
        
        const addressToDelete = state.customerAdresses[index].title;
        console.log("addressToDelete: ", addressToDelete);
        
        if (addressToDelete === '' || addressToDelete === undefined) {
            dispatch({type: 'DELETE_CUSTOMER', payload: index});
            return;
        }
        
        try {
            await deleteDoc(doc(db, `customerAddresses/${customerID}/addresses/${addressToDelete}`));
            console.log("Deleted document with path: " , `customerAddresses/${customerID}/addresses/${addressToDelete}`);
            dispatch({type: 'DELETE_CUSTOMER', payload: index});
        } catch (e){
            console.log("Error deleting document: ", error);
        }
    };
    
    return(
        <div className={"mt-5"}>
            <div>
                {state.customerAdresses.map((address, index ) => (
                    <AdressCustomerComponent
                        key={index}
                        id={id}
                        customerID={customerID}
                        data={address}
                        onDelete={() => deleteCustomer(index)}
                    />
                ))}
            </div>
            <div className={"m-2"}>
                <Button1
                    text="Add Address"
                    onclick={() => addCustomer({
                        title: '',
                        street: '',
                        zip: '',
                        city: '',
                        country:'',
                        phone:'',
                        id:id,
                    })} >Add Address</Button1>
            </div>
        </div>
    );
}

export default ListOfAdressCustomerComponents; 